import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/arquivos-temporarios'

class ArquivoTemporarioApiClient {
	async enviarTemporario(formData) {
		return await axios.post(`${URL_PATH}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
	}

	async excluirTemporario(idExternoPasta) {
		return await axios.delete(`${URL_PATH}/${idExternoPasta}`)
	}

	async baixarTemporario(id) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${id}`,
		}).build()

		return await axios.get(url, {
			responseType: 'arraybuffer',
		})
	}
}

export default new ArquivoTemporarioApiClient()
